import { Injectable } from '@angular/core';
import { AES, enc, mode, pad } from 'crypto-js'
import { retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root' 
})
export class CryptoService {

    constructor() { }

    public encryptString(str: string) {
        var key = enc.Utf8.parse('greenstone706173');
        var iv = enc.Utf8.parse('greenstone706173');

        return AES.encrypt(str, key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: mode.CBC,
                padding: pad.Pkcs7
            }).toString();
    }
    public dencryptString(str: string) {

        if(!str){
            return  ""; 
        }
        else{
        var key = enc.Utf8.parse('greenstone706173');
        var iv = enc.Utf8.parse('greenstone706173');
        return enc.Utf8.stringify(AES.decrypt(str, key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: mode.CBC,
                padding: pad.Pkcs7
            }));}
       
    }
}